import { FRONT_LOAD_TYPES, FRONT_LOAD_FEE_TYPE_OPTIONS } from './constants';

const { STANDARD, CUSTOM, LOI, VAH } = FRONT_LOAD_TYPES;

export const annualFeeChargeFrequencies = [
  { labelKey: 'monthly', value: 1 },
  { labelKey: 'quarterly', value: 3 },
  { labelKey: 'semiAnnualy', value: 6 },
  { labelKey: 'annualy', value: 12 },
];

export const planFeeTypes = [
  { labelKey: 'estimatedPercent', value: 0 },
  { labelKey: 'benchmarkPercent', value: 1 },
  { labelKey: 'customPercent', value: 2 },
];

export const payFeeMethods = [
  { labelKey: 'outOfPocket', value: 0 },
  { labelKey: 'saleOfShares', value: 1 },
];

export const payOnBeginOptions = [
  { labelKey: 'endOfPeriod', value: false },
  { labelKey: 'beginningOfPeriod', value: true },
];

export const booleanOptions = [
  { labelKey: 'yes', value: true },
  { labelKey: 'no', value: false },
];

export const redemptionChargeOptions = [
  { labelKey: 'yes', value: 1 },
  { labelKey: 'no', value: 0 },
];

export const vahRedemptionChargeOptions = [
  ...redemptionChargeOptions,
  { labelKey: 'variesAcrossHoldings', value: 2 },
];

export const frontLoadTypeOptions = [
  { labelKey: 'standard', value: STANDARD },
  { labelKey: 'custom', value: CUSTOM },
  { labelKey: 'letterOfIntent', value: LOI },
  { labelKey: 'variesAcrossHoldings', value: VAH },
];

export const securityFrontLoadFeeTypeOptions = [
  { labelKey: 'standard', value: FRONT_LOAD_FEE_TYPE_OPTIONS.STANDARD },
  { labelKey: 'customAmount', value: FRONT_LOAD_FEE_TYPE_OPTIONS.CUSTOM_AMOUNT },
  { labelKey: 'customPercent', value: FRONT_LOAD_FEE_TYPE_OPTIONS.CUSTOM_PERCENT },
  { labelKey: 'letterOfIntent', value: FRONT_LOAD_FEE_TYPE_OPTIONS.LOI },
];

export const tradingCommissionTypeOptions = [
  { labelKey: 'buyAndSell', value: 0 },
  { labelKey: 'buy', value: 1 },
  { labelKey: 'sell', value: 2 },
];
